const SvgCodeBrowserIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3327 7.5H1.66602M11.666 14.5833L13.7493 12.5L11.666 10.4167M8.33268 10.4167L6.24935 12.5L8.33268 14.5833M1.66602 6.5L1.66602 13.5C1.66602 14.9001 1.66602 15.6002 1.9385 16.135C2.17818 16.6054 2.56063 16.9878 3.03104 17.2275C3.56582 17.5 4.26588 17.5 5.66601 17.5H14.3327C15.7328 17.5 16.4329 17.5 16.9677 17.2275C17.4381 16.9878 17.8205 16.6054 18.0602 16.135C18.3327 15.6002 18.3327 14.9001 18.3327 13.5V6.5C18.3327 5.09987 18.3327 4.3998 18.0602 3.86502C17.8205 3.39462 17.4381 3.01217 16.9677 2.77248C16.4329 2.5 15.7328 2.5 14.3327 2.5L5.66602 2.5C4.26589 2.5 3.56582 2.5 3.03104 2.77248C2.56063 3.01217 2.17818 3.39462 1.9385 3.86502C1.66602 4.3998 1.66602 5.09987 1.66602 6.5Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgCodeBrowserIcon
